import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.statistics');
import { OnDestroy, OnInit } from '@angular/core';
import Chart from 'chart.js/auto';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-statistics',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.statistics/view.scss */
:host {
  --statistics-bg: var(--admin-canvas, #f4f6f8);
  --statistics-surface: var(--admin-surface, #ffffff);
  --statistics-surface-subtle: var(--admin-surface-subtle, #f8fafc);
  --statistics-border: var(--admin-border, #dce2ea);
  --statistics-border-strong: #cbd5e1;
  --statistics-text: var(--admin-text-strong, #111827);
  --statistics-text-subtle: var(--admin-text-muted, #64748b);
  --statistics-text-muted: var(--admin-text-faint, #94a3b8);
  --statistics-primary: var(--admin-primary, #4f46e5);
  --statistics-primary-dark: var(--admin-primary-dark, #3730a3);
  --statistics-primary-soft: var(--admin-primary-soft, #eef2ff);
  display: block;
  width: 100%;
  color: var(--statistics-text);
}

.statistics-page {
  width: min(100%, 1320px);
  padding: 24px 28px 40px;
}

.statistics-hero {
  margin-bottom: 14px;
}

.statistics-hero__row,
.statistics-filter-shell__head,
.statistics-panel__head,
.statistics-subsection-head,
.statistics-question-area__head,
.statistics-question__head,
.statistics-bar-row__top,
.statistics-legend-item,
.statistics-highlight__row,
.statistics-pagination,
.statistics-toptype-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.statistics-hero__title {
  margin: 0;
  color: var(--statistics-text);
  font-size: 25px;
  font-weight: 750;
  line-height: 1.25;
  letter-spacing: -0.025em;
}

.statistics-navigation-row {
  position: sticky;
  top: 0;
  z-index: 12;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding: 6px;
  overflow-x: auto;
  border: 1px solid var(--statistics-border);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.97);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.07);
  backdrop-filter: blur(10px);
  scrollbar-width: thin;
}

.statistics-form-tabs,
.statistics-jump-nav {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
}

.statistics-form-tabs {
  gap: 6px;
}

.statistics-form-tab {
  display: flex;
  min-width: 168px;
  min-height: 50px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 3px;
  padding: 7px 12px;
  border: 1px solid transparent;
  border-radius: 9px;
  background: transparent;
  color: #475569;
  text-align: left;
  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;
}

.statistics-form-tab:hover {
  background: #f8fafc;
  color: var(--statistics-text);
}

.statistics-form-tab.is-active {
  border-color: #c7d2fe;
  background: var(--statistics-primary-soft);
  color: var(--statistics-primary-dark);
}

.statistics-form-tab span {
  font-size: 14px;
  font-weight: 750;
  line-height: 1.3;
}

.statistics-form-tab small {
  color: var(--statistics-text-subtle);
  font-size: 11px;
  font-weight: 600;
}

.statistics-jump-nav {
  gap: 3px;
  padding-left: 8px;
  border-left: 1px solid var(--statistics-border);
}

.statistics-jump-nav button {
  min-height: 34px;
  padding: 0 11px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--statistics-text-subtle);
  font-size: 13px;
  font-weight: 650;
  white-space: nowrap;
}

.statistics-jump-nav button:hover {
  background: #f1f5f9;
  color: var(--statistics-text);
}

.statistics-filter-shell,
.statistics-panel,
.statistics-section {
  border: 1px solid var(--statistics-border);
  background: var(--statistics-surface);
  box-shadow: 0 3px 12px rgba(15, 23, 42, 0.035);
}

.statistics-filter-shell,
.statistics-panel {
  margin-bottom: 18px;
  padding: 20px;
  border-radius: 14px;
}

.statistics-filter-shell__title,
.statistics-panel__title,
.statistics-question-area__title {
  margin: 0;
  color: var(--statistics-text);
  font-size: 18px;
  font-weight: 750;
  line-height: 1.35;
  letter-spacing: -0.015em;
}

.statistics-filter-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.statistics-filter-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-top: 16px;
}

.statistics-filter-grid--two {
  width: min(100%, 820px);
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.statistics-filter-card__label,
.statistics-kpi__label,
.statistics-panel__count,
.statistics-subsection-count,
.statistics-question-area__count,
.statistics-section__count,
.statistics-question__ratio,
.statistics-metric-card__label,
.statistics-legend-item__value,
.statistics-bar-row__value,
.statistics-option-row__value {
  color: var(--statistics-text-subtle);
  font-size: 13px;
  font-weight: 650;
}

.statistics-select {
  width: 100%;
  min-height: 42px;
  margin-top: 7px;
  padding: 0 12px;
  border: 1px solid var(--statistics-border-strong);
  border-radius: 8px;
  background: #fff;
  color: var(--statistics-text);
  font-size: 14px;
  font-weight: 600;
  outline: none;
  transition: border-color 150ms ease, box-shadow 150ms ease;
}

.statistics-select:focus {
  border-color: #818cf8;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.13);
}

.statistics-reset-button,
.statistics-page-button,
.statistics-export-button {
  min-height: 36px;
  padding: 0 13px;
  border: 1px solid var(--statistics-border-strong);
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 13px;
  font-weight: 650;
}

.statistics-reset-button:hover,
.statistics-page-button:hover:not(:disabled) {
  border-color: #a5b4fc;
  background: var(--statistics-primary-soft);
  color: var(--statistics-primary-dark);
}

.statistics-export-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border-color: var(--statistics-primary);
  background: var(--statistics-primary);
  color: #fff;
}

.statistics-export-button:hover:not(:disabled) {
  border-color: var(--statistics-primary-dark);
  background: var(--statistics-primary-dark);
}

.statistics-page-button:disabled,
.statistics-export-button:disabled {
  cursor: not-allowed;
  opacity: 0.42;
}

.statistics-export-button__spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.45);
  border-top-color: #fff;
  border-radius: 50%;
  animation: statistics-spin 700ms linear infinite;
}

.statistics-state {
  display: flex;
  min-height: 120px;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 18px;
  border: 1px solid var(--statistics-border);
  border-radius: 14px;
  background: #fff;
  color: var(--statistics-text-subtle);
  font-size: 14px;
  font-weight: 650;
}

.statistics-state--loading::before {
  width: 18px;
  height: 18px;
  border: 2px solid #c7d2fe;
  border-top-color: var(--statistics-primary);
  border-radius: 50%;
  content: "";
  animation: statistics-spin 700ms linear infinite;
}

.statistics-state--error {
  border-color: #fecdd3;
  background: #fff1f2;
  color: #be123c;
}

@keyframes statistics-spin {
  to {
    transform: rotate(360deg);
  }
}
.statistics-kpis {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 18px;
  scroll-margin-top: 82px;
}

.statistics-kpi {
  min-width: 0;
  padding: 16px;
  border: 1px solid var(--statistics-border);
  border-radius: 12px;
  background: #fff;
}

.statistics-kpi__value {
  margin-top: 8px;
  color: var(--statistics-text);
  font-size: 26px;
  font-weight: 780;
  line-height: 1.1;
  letter-spacing: -0.025em;
}

.statistics-kpi--primary {
  border-color: var(--statistics-primary);
  background: linear-gradient(145deg, #4f46e5, #4338ca);
}

.statistics-kpi--primary .statistics-kpi__label {
  color: #e0e7ff;
}

.statistics-kpi--primary .statistics-kpi__value {
  color: #fff;
}

.statistics-kpi--completion,
.statistics-kpi--completed {
  border-color: #c7d2fe;
  background: #f8faff;
}

.statistics-kpi--completion .statistics-kpi__value,
.statistics-kpi--completed .statistics-kpi__value {
  color: var(--statistics-primary-dark);
}

.statistics-kpi--secondary {
  background: var(--statistics-surface-subtle);
}

.statistics-kpi--secondary .statistics-kpi__value {
  font-size: 23px;
}

.statistics-assessment {
  border-color: #c7d2fe;
  background: linear-gradient(180deg, #f8faff 0%, #fff 76%);
  scroll-margin-top: 82px;
}

.statistics-assessment__body--sgds {
  display: grid;
  grid-template-columns: minmax(240px, 0.7fr) minmax(0, 1.55fr);
  gap: 14px;
  align-items: stretch;
}

.statistics-assessment__metrics,
.statistics-assessment__details,
.statistics-assessment__domains,
.statistics-metric-grid {
  display: grid;
  gap: 12px;
}

.statistics-assessment__metrics {
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
}

.statistics-assessment__body--sgds .statistics-assessment__metrics,
.statistics-assessment__body--sgds .statistics-assessment__details {
  grid-template-columns: 1fr;
}

.statistics-assessment__details {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-top: 14px;
}

.statistics-assessment__body--sgds .statistics-assessment__details {
  margin-top: 0;
}

.statistics-assessment__body--sgds .statistics-assessment__block {
  height: 100%;
}

.statistics-metric-card,
.statistics-assessment__block {
  border: 1px solid var(--statistics-border);
  border-radius: 10px;
  background: var(--statistics-surface-subtle);
}

.statistics-metric-card {
  padding: 13px 14px;
}

.statistics-assessment__block {
  padding: 15px;
}

.statistics-assessment__value {
  margin-top: 6px;
  color: var(--statistics-primary-dark);
  font-size: 27px;
  font-weight: 780;
  line-height: 1.15;
  letter-spacing: -0.025em;
}

.statistics-metric-card__value {
  margin-top: 6px;
  color: var(--statistics-text);
  font-size: 15px;
  font-weight: 720;
  line-height: 1.5;
}

.statistics-metric-card__sub,
.statistics-assessment__notice {
  color: var(--statistics-text-subtle);
  font-size: 13px;
  line-height: 1.6;
}

.statistics-metric-card__sub {
  margin-top: 3px;
}

.statistics-assessment__subtitle {
  color: #334155;
  font-size: 14px;
  font-weight: 750;
}

.statistics-assessment__domains {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-top: 12px;
}

.statistics-assessment__notice {
  margin: 14px 0 0;
  padding-top: 12px;
  border-top: 1px solid #e0e7ff;
}

.statistics-distribution-panel,
.statistics-highlight-panel,
.statistics-trend-panel {
  scroll-margin-top: 82px;
}

.statistics-distribution-grid {
  display: grid;
  grid-template-columns: minmax(320px, 0.9fr) minmax(0, 1.45fr);
  gap: 14px;
  margin-top: 16px;
}

.statistics-distribution-block {
  min-width: 0;
  padding: 17px;
  border: 1px solid #e5e7eb;
  border-radius: 11px;
  background: var(--statistics-surface-subtle);
}

.statistics-subsection-title {
  margin: 0;
  color: #334155;
  font-size: 15px;
  font-weight: 750;
}

.statistics-empty {
  padding: 28px 12px;
  color: var(--statistics-text-muted);
  font-size: 14px;
  text-align: center;
}

.statistics-donut {
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr);
  align-items: center;
  gap: 20px;
  margin-top: 15px;
}

.statistics-donut__chart {
  position: relative;
  width: 142px;
  height: 142px;
  border-radius: 50%;
}

.statistics-donut__center {
  position: absolute;
  inset: 22%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #fff;
  text-align: center;
}

.statistics-donut__center-label {
  color: var(--statistics-text-subtle);
  font-size: 12px;
  font-weight: 650;
}

.statistics-donut__center-value {
  margin-top: 3px;
  color: var(--statistics-text);
  font-size: 24px;
  font-weight: 780;
}

.statistics-donut__legend {
  display: grid;
  gap: 9px;
}

.statistics-legend-item {
  padding-bottom: 9px;
  border-bottom: 1px solid #e5e7eb;
}

.statistics-legend-item:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}

.statistics-legend-item__name {
  display: flex;
  align-items: center;
  gap: 8px;
}

.statistics-legend-item__dot {
  width: 10px;
  height: 10px;
  flex: 0 0 auto;
  border-radius: 50%;
}

.statistics-legend-item__label,
.statistics-bar-row__label,
.statistics-option-row__label,
.statistics-matrix-row__title,
.statistics-toptype-row__label {
  color: #334155;
  font-size: 14px;
  font-weight: 650;
}

.statistics-bar-list {
  display: grid;
  gap: 13px;
  margin-top: 16px;
}

.statistics-bar-row__track,
.statistics-option-row__track {
  overflow: hidden;
  border-radius: 999px;
  background: #e2e8f0;
}

.statistics-bar-row__track {
  height: 8px;
  margin-top: 7px;
}

.statistics-bar-row__fill,
.statistics-option-row__fill {
  height: 100%;
  border-radius: inherit;
}

.statistics-bar-row__fill,
.statistics-option-row__fill--indigo {
  background: linear-gradient(90deg, #4f46e5, #818cf8);
}

.statistics-option-row__fill--emerald {
  background: linear-gradient(90deg, #059669, #34d399);
}

.statistics-highlight-list {
  display: grid;
  gap: 8px;
  margin-top: 16px;
}

.statistics-highlight {
  display: grid;
  grid-template-columns: minmax(130px, 0.48fr) minmax(260px, 1.5fr) minmax(220px, 0.85fr);
  align-items: center;
  gap: 16px;
  min-width: 0;
  padding: 13px 14px;
  border: 1px solid #e5e7eb;
  border-radius: 9px;
  background: var(--statistics-surface-subtle);
}

.statistics-highlight__section {
  overflow: hidden;
  color: var(--statistics-primary-dark);
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.statistics-highlight__label {
  min-width: 0;
  color: var(--statistics-text);
  font-size: 14px;
  font-weight: 680;
  line-height: 1.5;
}

.statistics-highlight__row {
  min-width: 0;
}

.statistics-highlight__summary {
  overflow: hidden;
  color: var(--statistics-text-subtle);
  font-size: 13px;
  line-height: 1.45;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.statistics-highlight__pct {
  flex: 0 0 auto;
  color: var(--statistics-primary);
  font-size: 14px;
  font-weight: 750;
}

.statistics-pagination {
  justify-content: flex-end;
  margin-top: 14px;
}

.statistics-pagination__info {
  min-width: 48px;
  color: var(--statistics-text-subtle);
  font-size: 13px;
  font-weight: 650;
  text-align: center;
}

.statistics-chart-shell {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid #eef0f4;
}

.statistics-trend-chart {
  height: 250px;
}

.statistics-question-area {
  scroll-margin-top: 82px;
}

.statistics-question-area__head {
  margin: 24px 2px 12px;
}

.statistics-section {
  margin-bottom: 12px;
  overflow: hidden;
  border-radius: 12px;
}

.statistics-section__head {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 17px 19px;
  border: 0;
  background: #fff;
  color: inherit;
  text-align: left;
}

.statistics-section__head:hover {
  background: #fafbff;
}

.statistics-section__title {
  margin: 0;
  color: var(--statistics-text);
  font-size: 16px;
  font-weight: 750;
  line-height: 1.4;
}

.statistics-section__desc {
  margin: 5px 0 0;
  color: var(--statistics-text-subtle);
  font-size: 13px;
  line-height: 1.55;
}

.statistics-section__meta {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 10px;
}

.statistics-section__toggle {
  min-width: 44px;
  padding: 5px 9px;
  border-radius: 6px;
  background: var(--statistics-primary-soft);
  color: var(--statistics-primary-dark);
  font-size: 12px;
  font-weight: 700;
  text-align: center;
}

.statistics-question-list {
  display: grid;
  gap: 12px;
  padding: 16px;
  border-top: 1px solid var(--statistics-border);
  background: #f8fafc;
}

.statistics-question {
  min-width: 0;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
}

.statistics-question__head {
  align-items: flex-start;
}

.statistics-question__no {
  display: inline-flex;
  min-width: 25px;
  height: 25px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  border-radius: 6px;
  background: var(--statistics-primary-soft);
  color: var(--statistics-primary-dark);
  font-size: 12px;
  font-weight: 750;
}

.statistics-question__label {
  color: var(--statistics-text);
  font-size: 15px;
  font-weight: 680;
  line-height: 1.55;
}

.statistics-question__ratio {
  flex: 0 0 auto;
  padding: 4px 8px;
  border-radius: 6px;
  background: #f1f5f9;
}

.statistics-option-row {
  display: grid;
  grid-template-columns: minmax(130px, 220px) minmax(100px, 1fr) 94px;
  align-items: center;
  gap: 12px;
}

.statistics-option-row__track {
  height: 8px;
}

.statistics-option-row__value {
  text-align: right;
}

.statistics-matrix-row {
  padding: 14px;
  border: 1px solid #e5e7eb;
  border-radius: 9px;
  background: var(--statistics-surface-subtle);
}

.statistics-matrix-row__title {
  margin-bottom: 10px;
}

.statistics-metric-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.statistics-metric-grid--wide {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.statistics-metric-grid--split {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.statistics-toptype-row {
  padding-bottom: 7px;
  border-bottom: 1px solid #e5e7eb;
}

.statistics-toptype-row:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}

.statistics-toptype-row__value {
  color: var(--statistics-text);
  font-size: 13px;
  font-weight: 700;
}

@media (max-width: 1180px) {
  .statistics-kpis {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .statistics-highlight {
    grid-template-columns: minmax(120px, 0.45fr) minmax(220px, 1.2fr) minmax(200px, 0.8fr);
  }
}
@media (max-width: 900px) {
  .statistics-page {
    padding: 20px;
  }
  .statistics-filter-grid,
  .statistics-filter-grid--two,
  .statistics-distribution-grid,
  .statistics-assessment__body--sgds {
    width: 100%;
    grid-template-columns: 1fr;
  }
  .statistics-metric-grid,
  .statistics-metric-grid--wide {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .statistics-highlight {
    grid-template-columns: minmax(110px, 0.45fr) minmax(0, 1.55fr);
  }
  .statistics-highlight__row {
    grid-column: 1/-1;
    padding-top: 8px;
    border-top: 1px solid #e5e7eb;
  }
}
@media (max-width: 767px) {
  .statistics-page {
    padding: 16px;
  }
  .statistics-hero__title {
    font-size: 22px;
  }
  .statistics-navigation-row {
    position: static;
    margin-right: -16px;
    margin-left: -16px;
    border-right: 0;
    border-left: 0;
    border-radius: 0;
    box-shadow: none;
    backdrop-filter: none;
  }
  .statistics-form-tab {
    min-width: 154px;
  }
  .statistics-filter-shell,
  .statistics-panel {
    padding: 17px;
  }
  .statistics-filter-shell__head {
    align-items: flex-start;
  }
  .statistics-filter-actions {
    flex-wrap: wrap;
    justify-content: flex-end;
  }
  .statistics-filter-shell__title,
  .statistics-panel__title,
  .statistics-question-area__title {
    font-size: 17px;
  }
  .statistics-kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .statistics-kpi {
    padding: 14px;
  }
  .statistics-kpi__value,
  .statistics-kpi--secondary .statistics-kpi__value {
    font-size: 22px;
  }
  .statistics-assessment__metrics,
  .statistics-assessment__details,
  .statistics-assessment__domains,
  .statistics-metric-grid,
  .statistics-metric-grid--wide,
  .statistics-metric-grid--split {
    grid-template-columns: 1fr;
  }
  .statistics-donut {
    grid-template-columns: 1fr;
    justify-items: center;
  }
  .statistics-donut__legend {
    width: 100%;
  }
  .statistics-highlight {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  .statistics-highlight__section {
    white-space: normal;
  }
  .statistics-highlight__row {
    grid-column: auto;
  }
  .statistics-section__head {
    align-items: flex-start;
    padding: 15px;
  }
  .statistics-section__meta {
    flex-direction: column;
    align-items: flex-end;
    gap: 6px;
  }
  .statistics-question-list {
    padding: 12px;
  }
  .statistics-question {
    padding: 14px;
  }
  .statistics-question__head {
    flex-direction: column;
  }
  .statistics-option-row {
    grid-template-columns: 1fr;
    gap: 7px;
  }
  .statistics-option-row__value {
    text-align: left;
  }
  .statistics-pagination {
    justify-content: space-between;
  }
}
/* Unified admin visual hierarchy */
.statistics-hero {
  margin-bottom: 16px;
  padding: 2px 2px 6px;
}

.statistics-hero__title {
  font-size: 24px;
  font-weight: 800;
}

.statistics-navigation-row {
  border-color: var(--statistics-border);
  background: rgba(255, 255, 255, 0.98);
  box-shadow: var(--admin-shadow-card, 0 1px 2px rgba(15, 23, 42, 0.04));
}

.statistics-form-tab {
  --form-accent: var(--statistics-primary);
  --form-soft: var(--statistics-primary-soft);
  position: relative;
}

.statistics-form-tab[data-form-code=original_survey] {
  --form-accent: var(--admin-primary, #4f46e5);
  --form-soft: var(--admin-primary-soft, #eef2ff);
}

.statistics-form-tab[data-form-code=geriatric_depression] {
  --form-accent: var(--admin-success, #047857);
  --form-soft: var(--admin-success-soft, #ecfdf5);
}

.statistics-form-tab[data-form-code=mmse] {
  --form-accent: var(--admin-warning, #b45309);
  --form-soft: var(--admin-warning-soft, #fffbeb);
}

.statistics-form-tab.is-active {
  border-color: var(--form-accent);
  background: var(--form-soft);
  box-shadow: inset 0 0 0 1px var(--form-soft);
  color: var(--form-accent);
}

.statistics-filter-shell {
  border-color: var(--statistics-border);
  background: radial-gradient(circle at 96% 10%, var(--statistics-primary-soft), rgba(255, 255, 255, 0) 28%), var(--statistics-surface);
  box-shadow: var(--admin-shadow-card, 0 1px 2px rgba(15, 23, 42, 0.04));
}

.statistics-filter-shell__title,
.statistics-panel__title,
.statistics-question-area__title {
  display: flex;
  align-items: center;
}

.statistics-filter-shell__title::before,
.statistics-panel__title::before,
.statistics-question-area__title::before {
  width: 7px;
  height: 7px;
  margin-right: 8px;
  border-radius: 999px;
  background: var(--statistics-primary);
  content: "";
}

.statistics-panel,
.statistics-section {
  border-color: var(--statistics-border);
  background: var(--statistics-surface);
  box-shadow: var(--admin-shadow-card, 0 1px 2px rgba(15, 23, 42, 0.04));
}

.statistics-panel__head {
  padding-bottom: 13px;
  border-bottom: 1px solid var(--admin-border-soft, #edf1f5);
}

.statistics-kpi {
  position: relative;
  overflow: hidden;
  border-color: var(--statistics-border);
  background: var(--statistics-surface);
  box-shadow: var(--admin-shadow-card, 0 1px 2px rgba(15, 23, 42, 0.04));
}

.statistics-kpi::before {
  position: absolute;
  top: -22px;
  right: -18px;
  width: 64px;
  height: 64px;
  border-radius: 999px;
  background: var(--kpi-accent, var(--statistics-primary));
  content: "";
  opacity: 0.09;
}

.statistics-kpi--primary {
  --kpi-accent: var(--statistics-primary);
}

.statistics-kpi--completion,
.statistics-kpi--completed {
  --kpi-accent: var(--admin-success, #047857);
}

.statistics-kpi--secondary {
  --kpi-accent: var(--admin-text-muted, #64748b);
}

.statistics-distribution-block,
.statistics-assessment__block,
.statistics-metric-card,
.statistics-question {
  border-color: var(--admin-border-soft, #edf1f5);
  background: var(--statistics-surface-subtle);
}

.statistics-select {
  padding-right: 42px;
  border-color: var(--statistics-border-strong);
  border-radius: 9px;
  background-color: var(--statistics-surface);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'%3E%3Cpath d='m6 8 4 4 4-4' stroke='%2364748b' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 20px 20px;
  appearance: none;
  cursor: pointer;
}

.statistics-export-button {
  background: var(--statistics-primary);
  box-shadow: 0 5px 12px rgba(79, 70, 229, 0.16);
}

.statistics-reset-button {
  border-color: var(--statistics-border);
  background: var(--statistics-surface);
  color: var(--statistics-text-subtle);
}

@media (max-width: 767px) {
  .statistics-page {
    padding: 16px 16px 32px;
  }
}`],
})
export class PageAdminStatisticsComponent implements OnInit, OnDestroy {
    public loading: boolean = true;
    public exportingStatistics: boolean = false;
    public errorMessage: string = '';
    public filters: any = {
        form_code: 'original_survey',
        gender: '',
        age_band: '',
    };
    public filterOptions: any = { genders: [], age_bands: [] };
    public forms: any[] = [];
    public form: any = {
        code: 'original_survey',
        title: '한의 검진 설문(CRF)',
    };
    public assessment: any = null;
    public population: any = { total: 0, pending: 0, in_progress: 0, completed: 0, expired: 0 };
    public cohort: any = { total: 0, pending: 0, in_progress: 0, completed: 0, expired: 0 };
    public summary: any = { submitted_total: 0, filtered_total: 0, avg_age: null, completion_rate: 0, dominant_age_band: '-', male_pct: 0, female_pct: 0 };
    public distributions: any = { genders: [], age_bands: [] };
    public daily: any[] = [];
    public highlights: any[] = [];
    public sections: any[] = [];
    public selectedSectionKey: string = '';
    public expandedSectionKeys: { [key: string]: boolean } = {};
    public highlightPage: number = 1;
    public readonly highlightPageSize: number = 3;
    private trendChart: Chart | null = null;
    private readonly trendCanvasId = 'statistics-trend-chart';

    constructor(@Inject( Service) public service: Service) { }

    private payload(data: any): any {
        if (data && data.data !== undefined) {
            return data.data;
        }
        return data || {};
    }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public ngOnDestroy() {
        this.destroyTrendChart();
    }

    public async load() {
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call('overview', this.filters);
            if (code !== 200) {
                this.errorMessage = (data && data.message) || '통계 데이터를 불러오지 못했습니다.';
            } else {
                const payload = this.payload(data);
                this.population = payload.population || this.population;
                this.cohort = payload.cohort || this.cohort;
                this.filterOptions = {
                    genders: payload.filters?.genders || this.filterOptions.genders,
                    age_bands: payload.filters?.age_bands || this.filterOptions.age_bands,
                };
                this.forms = payload.forms || this.forms;
                this.form = payload.form || this.form;
                this.assessment = payload.assessment || null;
                this.filters = {
                    form_code: this.form?.code || this.filters.form_code || 'original_survey',
                    ...(payload.filters?.applied || {}),
                };
                this.summary = payload.summary || this.summary;
                const distributions = payload.distributions || this.distributions;
                this.distributions = {
                    ...distributions,
                    genders: (distributions?.genders || []).filter((item: any) => Number(item?.count || 0) > 0),
                    age_bands: (distributions?.age_bands || []).filter((item: any) => Number(item?.count || 0) > 0),
                };
                this.daily = payload.daily || [];
                this.highlights = payload.highlights || [];
                this.sections = payload.sections || [];
                this.highlightPage = 1;
                this.selectedSectionKey = this.resolveSelectedSectionKey(this.selectedSectionKey);
                this.syncExpandedSections();
            }
        } catch (e: any) {
            this.errorMessage = e?.message || '통계 데이터를 불러오지 못했습니다.';
        }

        this.loading = false;
        await this.service.render();
        this.renderTrendChart();
    }

    public async setFilter(key: string, value: any) {
        this.filters[key] = value || '';
        await this.load();
    }

    public async setForm(formCode: string) {
        if (!formCode || formCode === this.filters.form_code) return;
        if (!(this.forms || []).some((item: any) => item.code === formCode)) return;
        this.filters.form_code = formCode;
        this.selectedSectionKey = '';
        this.highlightPage = 1;
        await this.load();
    }

    public async resetFilters() {
        this.filters = {
            form_code: this.filters.form_code || 'original_survey',
            gender: '',
            age_band: '',
        };
        this.selectedSectionKey = '';
        this.highlightPage = 1;
        await this.load();
    }

    private parseDownloadFilename(
        contentDisposition: string | null,
        fallback: string,
    ): string {
        if (!contentDisposition) return fallback;
        const utfMatch = contentDisposition.match(
            /filename\*=UTF-8''([^;]+)/i,
        );
        if (utfMatch && utfMatch[1]) {
            try {
                return decodeURIComponent(utfMatch[1]);
            } catch (e) {
                return utfMatch[1];
            }
        }
        const asciiMatch = contentDisposition.match(
            /filename="?([^";]+)"?/i,
        );
        return (
            asciiMatch && asciiMatch[1]
            ? asciiMatch[1]
            : fallback
        );
    }

    public async downloadStatistics() {
        if (
            this.loading
            || this.exportingStatistics
            || Number(this.summary?.filtered_total || 0) <= 0
        ) return;

        this.exportingStatistics = true;
        await this.service.render();
        try {
            const params = new URLSearchParams();
            params.set(
                'form_code',
                this.filters?.form_code || 'original_survey',
            );
            if (this.filters?.gender) {
                params.set('gender', this.filters.gender);
            }
            if (this.filters?.age_band) {
                params.set('age_band', this.filters.age_band);
            }
            if (this.selectedSectionKey) {
                params.set('section_key', this.selectedSectionKey);
            }

            const response = await fetch(
                '/api/admin/statistics/xlsx?' + params.toString(),
                {
                    method: 'GET',
                    credentials: 'same-origin',
                },
            );
            const contentType = response.headers.get('Content-Type') || '';
            if (!response.ok || contentType.includes('application/json')) {
                let message = '통계 Excel 다운로드에 실패했습니다.';
                try {
                    const body = await response.json();
                    message = (
                        body?.data?.message
                        || body?.message
                        || message
                    );
                } catch (e) {}
                alert(message);
                return;
            }

            const blob = await response.blob();
            const filename = this.parseDownloadFilename(
                response.headers.get('Content-Disposition'),
                'survey-statistics.xlsx',
            );
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(url);
        } catch (e: any) {
            alert(
                '네트워크 오류: '
                + (e?.message || String(e)),
            );
        } finally {
            this.exportingStatistics = false;
            await this.service.render();
        }
    }

    public async setSectionFilter(value: any) {
        this.selectedSectionKey = value || '';
        this.highlightPage = 1;
        if (this.selectedSectionKey) {
            this.expandedSectionKeys[this.selectedSectionKey] = true;
        }
        await this.service.render();
    }

    public scrollToBlock(id: string) {
        const element = document.getElementById(id);
        if (!element) return;
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    private destroyTrendChart() {
        if (this.trendChart) {
            this.trendChart.destroy();
            this.trendChart = null;
        }
    }

    private renderTrendChart() {
        this.destroyTrendChart();
        if (!this.daily || this.daily.length === 0) return;

        const canvas = document.getElementById(this.trendCanvasId) as HTMLCanvasElement | null;
        if (!canvas) return;

        const labels = this.daily.map((item: any) => this.shortDate(item.date));
        const data = this.daily.map((item: any) => Number(item.count || 0));
        const max = Math.max(...data, 1);

        this.trendChart = new Chart(canvas, {
            type: 'line',
            data: {
                labels,
                datasets: [{
                    label: this.activeFormTitle() + ' 완료 건수',
                    data,
                    borderColor: '#4f46e5',
                    backgroundColor: 'rgba(79, 70, 229, 0.1)',
                    fill: true,
                    pointRadius: 4,
                    pointHoverRadius: 7,
                    pointHitRadius: 16,
                    pointBackgroundColor: '#4f46e5',
                    pointBorderColor: '#ffffff',
                    pointBorderWidth: 2,
                    pointHoverBorderWidth: 3,
                    tension: 0.35,
                }],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                animation: false,
                interaction: {
                    mode: 'index',
                    intersect: false,
                },
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        displayColors: false,
                        callbacks: {
                            title: (items) => items[0]?.label || '',
                            label: (context) => `완료 ${context.formattedValue}건`,
                        },
                    },
                },
                scales: {
                    x: {
                        grid: { display: false, drawBorder: false },
                        border: { display: false },
                        ticks: {
                            color: '#64748b',
                            maxRotation: 0,
                            autoSkip: true,
                            maxTicksLimit: 7,
                            font: { size: 12 },
                        },
                    },
                    y: {
                        beginAtZero: true,
                        suggestedMax: max,
                        border: { display: false },
                        grid: {
                            color: 'rgba(148, 163, 184, 0.18)',
                            drawBorder: false,
                        },
                        ticks: {
                            stepSize: max > 1 ? undefined : 1,
                            color: '#64748b',
                            font: { size: 12 },
                        },
                    },
                },
            },
        });
    }

    public formatValue(value: any, suffix: string = '', decimals: any = null): string {
        if (value === null || value === undefined || value === '') {
            return '-';
        }
        if (typeof value === 'number') {
            const places = Number(decimals);
            const useFixed = (
                decimals !== null
                && decimals !== undefined
                && decimals !== ''
                && Number.isInteger(places)
                && places >= 0
            );
            const text = useFixed
                ? value.toFixed(places)
                : (Number.isInteger(value) ? String(value) : value.toFixed(1));
            return suffix ? text + suffix : text;
        }
        return suffix ? String(value) + suffix : String(value);
    }

    public percent(value: number): string {
        if (value === null || value === undefined) return '0%';
        return this.formatValue(value, '%');
    }

    public maxDaily(): number {
        let max = 0;
        for (const item of this.daily) {
            if ((item?.count || 0) > max) max = item.count;
        }
        return max || 1;
    }

    public barHeight(count: number): string {
        const max = this.maxDaily();
        const height = Math.max(6, Math.round((count / max) * 100));
        return height + '%';
    }

    public responseRatio(question: any): string {
        const total = this.summary?.filtered_total || 0;
        const count = question?.response_count || 0;
        return total > 0 ? `${count}/${total}` : '0/0';
    }

    public sectionOptions(): any[] {
        const options: any[] = [{ value: '', label: '전체' }];
        for (const section of this.sections || []) {
            options.push({ value: section.key, label: section.title });
        }
        return options;
    }

    public hasSectionFilter(): boolean {
        return (this.sections || []).length > 1;
    }

    public visibleSections(): any[] {
        if (!this.selectedSectionKey) return this.sections || [];
        return (this.sections || []).filter((section: any) => section.key === this.selectedSectionKey);
    }

    public isSectionExpanded(section: any): boolean {
        return !!this.expandedSectionKeys[section?.key || ''];
    }

    public async toggleSection(section: any) {
        const key = section?.key || '';
        if (!key) return;
        this.expandedSectionKeys[key] = !this.expandedSectionKeys[key];
        await this.service.render();
    }

    public filteredHighlights(): any[] {
        if (!this.selectedSectionKey) return this.highlights || [];
        return (this.highlights || []).filter((item: any) => item.section_key === this.selectedSectionKey);
    }

    public highlightTotalPages(): number {
        const total = this.filteredHighlights().length;
        return Math.max(1, Math.ceil(total / this.highlightPageSize));
    }

    public pagedHighlights(): any[] {
        const items = this.filteredHighlights();
        const start = (this.highlightPage - 1) * this.highlightPageSize;
        return items.slice(start, start + this.highlightPageSize);
    }

    public async setHighlightPage(page: number) {
        if (page < 1 || page > this.highlightTotalPages()) return;
        this.highlightPage = page;
        await this.service.render();
    }

    public hasActiveDemographicFilter(): boolean {
        return !!(this.filters?.gender || this.filters?.age_band);
    }

    public cohortLabel(): string {
        return this.hasActiveDemographicFilter() ? '필터 대상자' : '전체 대상자';
    }

    public activeFormTitle(): string {
        return this.formTitle(this.form);
    }

    public formTitle(form: any): string {
        if (form?.code === 'original_survey') {
            return '한의 검진 설문(CRF)';
        }
        return form?.title || '설문';
    }

    public statisticsDescription(): string {
        if (this.form?.code === 'geriatric_depression') {
            return '완료된 SGDS-K의 문항별 응답과 관리자 전용 채점 결과를 집계합니다.';
        }
        if (this.form?.code === 'mmse') {
            return '완료된 MMSE-K의 평가항목 점수, 보정 총점과 선별검사 판정을 집계합니다.';
        }
        return '완료된 한의 검진 설문(CRF)의 대상자 문항과 관리자 임상 기록을 함께 집계합니다.';
    }

    public genderDonutStyle(): string {
        const items = this.distributions?.genders || [];
        const colors: any = { M: '#4f46e5', F: '#ec4899', O: '#14b8a6' };
        let offset = 0;
        const parts: string[] = [];
        for (const item of items) {
            const pct = Math.max(0, Number(item?.pct || 0));
            const next = offset + pct;
            const color = colors[item?.key] || '#94a3b8';
            parts.push(`${color} ${offset}% ${next}%`);
            offset = next;
        }
        if (parts.length === 0 || offset <= 0) {
            return 'conic-gradient(#e2e8f0 0 100%)';
        }
        if (offset < 100) {
            parts.push(`#e2e8f0 ${offset}% 100%`);
        }
        return `conic-gradient(${parts.join(', ')})`;
    }

    public showDailyLabel(index: number, total: number): boolean {
        if (total <= 7) return true;
        return index === 0 || index === total - 1 || index % 5 === 0;
    }

    public shortDate(value: string): string {
        if (!value) return '';
        return value.slice(5).replace('-', '/');
    }

    private resolveSelectedSectionKey(currentKey: string): string {
        const sections = this.sections || [];
        if (!currentKey || sections.length === 0) return '';

        if (sections.find((section: any) => section.key === currentKey)) {
            return currentKey;
        }

        return '';
    }

    private syncExpandedSections() {
        const next: { [key: string]: boolean } = {};
        for (const section of this.sections || []) {
            const key = section?.key || '';
            if (key && this.expandedSectionKeys[key]) {
                next[key] = true;
            }
        }

        if (this.selectedSectionKey) {
            next[this.selectedSectionKey] = true;
        } else if (!Object.keys(next).length && this.sections?.[0]?.key) {
            next[this.sections[0].key] = true;
        }
        this.expandedSectionKeys = next;
    }
}

export default PageAdminStatisticsComponent;